import { cx } from 'emotion';
import { mergeRight } from 'ramda';
import React, { CSSProperties } from 'react';

import defaultCloseIcon from '@ezugi/static/icons/close.svg';

import { Icon } from '../../../primitives/src';
import {
  headerContainer, headerPart, center, headerTitle, iconClassName,
} from './DrawerHeader.css';
import { IconType } from './types';

const isSvgString = (x: IconType): x is string => typeof x === 'string';

type DrawerHeaderProps = {
  title?: string;
  icon?: IconType;
  drawerBackIcon?: boolean;
  leftIcon?: IconType;
  onLeftIconClick?: (e: React.MouseEvent<HTMLDivElement>) => void;
  rightIcon?: IconType;
  onRightIconClick?: (e: React.MouseEvent<HTMLDivElement>) => void;
  className?: string;
  style?: CSSProperties;
}

const DrawerHeader = (props: DrawerHeaderProps) => {
  const {
    icon,
    drawerBackIcon = true,
    title,
    leftIcon,
    onLeftIconClick,
    rightIcon = defaultCloseIcon,
    onRightIconClick,
    className,
    style,
  } = props;

  const commonIconProps = {
    className: iconClassName,
    size: 18,
  };

  const leftIconProps = leftIcon && drawerBackIcon
    ? mergeRight(
      commonIconProps,
      isSvgString(leftIcon) ? { svg: leftIcon, onClick: onLeftIconClick } : leftIcon
    )
    : undefined;

  const centerIconProps = icon ? mergeRight(
    commonIconProps,
    isSvgString(icon) ? { svg: icon } : icon
  ) : undefined;

  const rightIconProps = mergeRight(
    commonIconProps,
    isSvgString(rightIcon) ? { svg: rightIcon, onClick: onRightIconClick } : rightIcon
  );

  return (
    <header
      className={cx(headerContainer, className)}
      style={style}
    >
      <div className={headerPart}>
        {leftIcon && leftIconProps && <Icon {...leftIconProps} />}
      </div>
      <div className={center}>
        {icon && centerIconProps && <Icon {...centerIconProps} />}
        <h3 className={headerTitle}>
          {title}
        </h3>
      </div>
      <div className={headerPart}>
        {rightIcon && <Icon {...rightIconProps} />}
      </div>
    </header>
  );
};

export default DrawerHeader;
